import { cn } from "./cn";
import { useI18n } from "../i18n";

/** Defect C — visible feedback when the zone manifest cannot be loaded
 *  (dots, RESERVE labels and Reveal Areas depend on it). Auto-retry runs
 *  in `useZoneManifest`; the button only triggers an immediate retry. */
export function ZoneUnavailableNotice({ className, onRetry }: { className?: string; onRetry?: () => void }) {
  const { t } = useI18n();
  return (
    <div
      role="status"
      data-testid="zone-unavailable-notice"
      className={cn(
        "flex items-center gap-2 px-3 h-9 rounded-pill neon-glass pointer-events-auto select-none",
        "max-w-[calc(100vw-1rem)] font-mono text-[10px] tracking-[0.12em] uppercase text-text-secondary",
        className,
      )}
    >
      <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-neon-coral shrink-0" />
      <span className="truncate">{t("grid.toolbar.zonesUnavailable")}</span>
      {onRetry && (
        <button
          type="button"
          data-testid="zone-unavailable-retry"
          onClick={onRetry}
          className="shrink-0 text-neon-teal hover:text-text-primary transition-colors duration-fast"
        >
          {t("grid.toolbar.zonesRetry")}
        </button>
      )}
    </div>
  );
}
